import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reveal } from './Reveal';

export const LawBenefits: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      id: t('law.benefits.items.01.id', { defaultValue: '01' }),
      title: t('law.benefits.items.01.title'),
      desc: t('law.benefits.items.01.desc'),
      highlight: t('law.benefits.items.01.highlight')
    },
    {
      id: t('law.benefits.items.02.id', { defaultValue: '02' }),
      title: t('law.benefits.items.02.title'),
      desc: t('law.benefits.items.02.desc'),
      highlight: t('law.benefits.items.02.highlight')
    },
    {
      id: t('law.benefits.items.03.id', { defaultValue: '03' }),
      title: t('law.benefits.items.03.title'),
      desc: t('law.benefits.items.03.desc'),
      highlight: t('law.benefits.items.03.highlight')
    },
    {
      id: t('law.benefits.items.04.id', { defaultValue: '04' }),
      title: t('law.benefits.items.04.title'),
      desc: t('law.benefits.items.04.desc'),
      highlight: t('law.benefits.items.04.highlight')
    }
  ];

  return (
    <section className="py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <Reveal>
          <div className="flex flex-col md:flex-row justify-between items-end mb-24 border-b border-gray-900 pb-8">
            <h2 className="text-5xl md:text-7xl font-bold text-gray-900 tracking-tighter leading-none">
              {t('law.benefits.title_line1')}<br />{t('law.benefits.title_line2')}
            </h2>
            <p className="text-gray-500 max-w-md text-right mt-8 md:mt-0 text-lg">
              {t('law.benefits.subtitle')}
            </p>
          </div>
        </Reveal>

        {/* Architectural Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-gray-200">
          {benefits.map((item, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="group p-12 border-b border-r border-gray-200 hover:bg-indigo-50/30 transition-all duration-500 min-h-[300px] flex flex-col justify-between relative overflow-hidden">

                <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="text-indigo-600 text-xs font-bold uppercase tracking-widest">{item.highlight}</span>
                </div>

                <div className="text-xs font-mono text-gray-400 mb-8">
                  {item.id}
                </div>

                <div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6 group-hover:translate-x-2 transition-transform duration-300">
                    {item.title}
                  </h3>
                  <p className="text-gray-500 leading-relaxed text-lg max-w-sm">
                    {item.desc}
                  </p>
                </div>

              </div>
            </Reveal>
          ))}
        </div>

        {/* Footer Bar */}
        <Reveal delay={0.4}>
          <div className="border-t border-gray-200 mt-0 py-12 text-center">
            <div className="inline-block px-3 py-1 bg-indigo-50 text-indigo-600 text-[10px] font-mono font-bold uppercase tracking-widest mb-4 border border-indigo-100">
              {t('law.benefits.footer_tagline')}
            </div>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto font-light">
              {t('law.benefits.footer_text')}
            </p>
          </div>
        </Reveal>

      </div>
    </section>
  );
};
